import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ProjetoConfiguracao } from 'src/app/shared/models/projeto-configuracao.model';
import { ProjetoConfiguracaoService } from 'src/app/shared/services/projeto-configuracao.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-geral',
  templateUrl: './configuracao-geral.component.html',
  styleUrls: ['./configuracao-geral.component.scss'],
})
export class ConfiguracaoGeralComponent extends BaseFormComponent<ProjetoConfiguracao> implements OnInit {

  constructor(
    private projetoConfiguracaoService: ProjetoConfiguracaoService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.initForm();
  }

  initForm() {
    this.projetoConfiguracaoService.show(1).subscribe({
      next: (res: ProjetoConfiguracao) => {
        if (res) {
          this.form.patchValue(res);
        }
        this.loaded()
      },
      error: (error) => {
        this.loaded()
        this.msgError(error.error.message);
      },
    });

    this.form = new FormGroup({
      id: new FormControl('', [Validators.required]),
      status_alert: new FormControl('', [Validators.required, Validators.pattern(/^\d+$/), Validators.max(100)]),
      status_warn: new FormControl('', [Validators.required, Validators.pattern(/^\d+$/), Validators.max(100)]),
      status_ok: new FormControl('', [Validators.required, Validators.pattern(/^\d+$/), Validators.max(100)]),
    });
  }

  voltar() {
    this.navigation.back();
  }

  getDataCreate(): ProjetoConfiguracao {
    let data: ProjetoConfiguracao;
    data = Object.assign({}, data, this.form.value);
    return data;
  }

  salvar() {
    if (this.form.valid) {
      this.loading();
      this.projetoConfiguracaoService.update(this.getDataCreate()).subscribe({
        next: (result: ProjetoConfiguracao) => {
          this.loaded()
          this.msgSuccess('Cadastro alterado com sucesso!');
        },
        error: (error) => {
          this.loaded()
          this.msgError(error.error.message);
        },
      });
    } else {
      this.markAsDirty();
    }
  }
}
